import { lazy, Suspense } from 'react';

/**
 * Loads the map picker on demand.
 *
 * Leaflet and its stylesheet are a sizeable chunk of the bundle, and most
 * screens never show a map — a booking at an address already on file never
 * needs one. Deferring the import keeps it out of the initial download and
 * fetches it the moment a picker is actually rendered.
 *
 * Every consumer should import this rather than MapPicker directly; the props
 * are identical.
 */
const MapPicker = lazy(() => import('./MapPicker.jsx'));

export default function LazyMapPicker(props) {
  return (
    <Suspense
      fallback={
        <div className="map-canvas map-loading">
          <span className="spinner" />
          <span className="small dim">Loading map…</span>
        </div>
      }
    >
      <MapPicker {...props} />
    </Suspense>
  );
}
